import TaxonomyFilter from '@/components/selector/taxonomy-filter/taxonomy-filter';
import { SubjectModel } from '@/models/taxonomy/subject';
import { profileAPI } from '@/providers/apis/profile/profile';
import Behavior from '@/routers/views/learners/learner-identity/behavior/behavior';
import { Vue, Component, Prop } from 'vue-property-decorator';
import LearnerProficiencyChart from '../learner-proficiency-chart/learner-proficiency-chart';
import axios from 'axios';
import { learnerAPI } from '@/providers/apis/learner/learner';
import { LearnerVector } from '@/models/proficiency/learner-vector';
import { LEARNER_MINDSETS_VECTORS, TEMP_CONST_LEARNER, VECTOR_VALUES } from '@/utils/constants';
import VectorChart from '@/routers/views/learners/learner-identity/vector-chart/vector-chart';
import moment from 'moment';

@Component({
    name: 'learner-identity-chart-line',
    components: {
        'behavior': Behavior,
        'learner-proficiency-chart-content': LearnerProficiencyChart,
        'vector-chart': VectorChart,
    },
})

export default class LearningIdentityChartLine extends Vue {

    @Prop()
    public activeMarker: any;

    // -----------------------------------------------------------
    // Properties

    private taxonomyFiler: TaxonomyFilter = new TaxonomyFilter();

    private hiddenSubjects: any = ['SK.XAPI', 'SK.SKS', 'SK.SEL'];

    @Prop({default: 'popover'})
    private elementId!: string;

    @Prop({default: 'e8a409f5-7fd9-4027-8955-3eda9322413f'})
    private studentId!: string;

    @Prop()
    private isShowCaseView!: boolean;

    private selectedSubjects: any = [];

    private rotateIndex = 5;

    private activeIndex = 5;

    private storedBox: any = [];

    private contentLoading: any = false;

    private cogAtData = [
        {
            label: 'Talk-Out',
            competencies: [{
                name: 'mastered',
                count: 3,
            }, {
                name: 'inprogress',
                count: 0,
            }, {
                name: 'notstarted',
                count: 2,
            }],
        },
        {
            label: 'Tantrum',
            competencies: [{
                name: 'mastered',
                count: 2,
            }, {
                name: 'notstarted',
                count: 2,
            }, {
                name: 'notstarted',
                count: 1,
            }],
        },
        {
            label: 'Out of Seat',
            competencies: [{
                name: 'mastered',
                count: 1,
            }, {
                name: 'inprogress',
                count: 1,
            }, {
                name: 'notstarted',
                count: 3,
            }],
        },
    ];

    private learningChallenges = [
        {
            label: 'Talk-Out',
            competencies: [{
                name: 'mastered',
                count: 2,
            }, {
                name: 'inprogress',
                count: 1,
            }, {
                name: 'notstarted',
                count: 2,
            }],
        },
        {
            label: 'Tantrum',
            competencies: [{
                name: 'mastered',
                count: 1,
            }, {
                name: 'notstarted',
                count: 0,
            }, {
                name: 'notstarted',
                count: 4,
            }],
        },
        {
            label: 'Out of Seat',
            competencies: [{
                name: 'mastered',
                count: 2,
            }, {
                name: 'inprogress',
                count: 0,
            }, {
                name: 'notstarted',
                count: 3,
            }],
        },
        {
            label: 'Engagement',
            competencies: [{
                name: 'mastered',
                count: 4,
            }, {
                name: 'inprogress',
                count: 0,
            }, {
                name: 'notstarted',
                count: 1,
            }],
        },
        {
            label: 'Engagement',
            competencies: [{
                name: 'mastered',
                count: 2,
            }, {
                name: 'inprogress',
                count: 1,
            }, {
                name: 'notstarted',
                count: 1,
            }],
        },
    ];

    private treeBox: any = [
        {
            name: 'Disposition',
            icon: 'psychology',
            filterKey: 'mindset',
        },
        {
            name: 'Behavior',
            icon: 'light_mode',
            filterKey: 'mindset',
        },
        {
            name: 'Abilities',
            icon: 'ac_unit',
            filterKey: 'context',
        },
        {
            name: 'CogAT',
            icon: 'ac_unit',
            filterKey: 'context',
            chartData: this.cogAtData,
        },
        {
            name: 'Learning Challenges',
            icon: 'ac_unit',
            filterKey: 'context',
            chartData: this.learningChallenges,
        },
        {
            name: 'Community',
            icon: 'language',
            filterKey: 'citizenship',
        },
        {
            name: 'Biographical',
            icon: 'contacts',
            filterKey: 'bio-data',
        },
    ];

    private studentDetails: any = {};

    private isLoading: boolean = false;

    private facetsList: any = [
        {
            name: 'Mindsets',
            icon: 'psychology',
            key: 'mindset',
        },
        {
            name: 'Community',
            icon: 'language',
            key: 'citizenship',
        },
        // {
        //     name: 'Behavior',
        //     icon: 'light_mode',
        //     key: 'mindset',
        // },
        {
            name: 'Abilities',
            icon: 'ability',
            key: 'context',
        },
        {
            name: 'Bio Data',
            icon: 'document_scanner',
            key: 'bio-data',
        },
        {
            name: 'Knowledge',
            icon: 'emoji_objects',
            key: 'knowledge-data',
        },
    ];

    public onChartLoaded(chartData: any) {
        this.$emit('onChartLoaded', chartData);
    }



    // -----------------------------------------------------------
    // Hooks


    private async mounted() {
        await this.fetchUserDetails();
        this.fetchTaxonomyFilter();
        this.$nextTick().then(() => {
            this.$root.$emit('bv::show::popover');
        });
    }

    // -----------------------------------------------------------
    // Actions

    private onShowFacets() {
        let pathUrl = `/learners/${this.studentId}?filter=true`;
        if (this.isShowCaseView) {
            pathUrl += '&isShowCaseView=true';
        }
        this.$router.push(pathUrl);
    }

    private onShowProficiency(box: any) {
        // const componentData = box.componentData ? box.componentData.propData.subject : null;
        // if (componentData) {
        //     const activeSubject = JSON.stringify(componentData);
        //     let pathUrl = `/learners/${this.studentId}
        // ?filter=true&activeSubject=${window.btoa(encodeURIComponent(activeSubject))}`;
        //     if (this.isShowCaseView) {
        //         pathUrl += '&isShowCaseView=true';
        //     }
        //     this.$router.push(pathUrl);
        // }
        this.$emit('onShowProficiency');
    }

    private async onSelectPoint(item: any, elementIndex: number) {
        await this.loadContent();
        const rotateIndex = this.rotateIndex;
        const position = elementIndex - rotateIndex;
        const rotateAngle = position * 72;
        // rotateAngle = rotateAngle + 90;
        const studentIdentity = this.$refs.studentIdentity as HTMLElement;
        studentIdentity.style.transform = `rotate(${rotateAngle}deg)`;
        this.activeIndex = elementIndex;
        this.treeBox = [...this.storedBox].filter((box) => box.filterKey === item.key);
        this.$nextTick().then(() => {
            setTimeout(() => {
                this.contentLoading = false;
                // this.$root.$emit('bv::show::popover');
            }, 800);
        });
    }

    // ------------------------------------------------------------------------
    // Methods

    private async fetchUserDetails() {
        this.isLoading = true;
        await axios.all([
            learnerAPI.fetchLearnerVectors({user: this.studentId}) as any,
            profileAPI.fetchUserProfiles(this.studentId),
        ]).then(axios.spread((learnerVectorPoints: LearnerVector[], userDetails) => {
            this.studentDetails = userDetails[0];
            if (TEMP_CONST_LEARNER.indexOf(this.studentId) !== -1) {
                learnerVectorPoints = VECTOR_VALUES;
            }
            const activeList = LEARNER_MINDSETS_VECTORS;
            this.treeBox[0].componentData = {
                name: 'vector-chart',
                propData: {
                    chartData: learnerVectorPoints.filter((item) => activeList.indexOf(item.label) !== -1),
                    isSmallCard: true,
                    isShowScale: true,
                    isShowText: true,
                },
            };
            this.treeBox[4].componentData = {
                name: 'vector-chart',
                propData: {
                    chartData: learnerVectorPoints.filter((item) => activeList.indexOf(item.label) === -1),
                    isSmallCard: true,
                    isShowScale: true,
                    isShowText: true,
                },
            };
        }));
    }

    private fetchTaxonomyFilter() {
        this.taxonomyFiler.userId = this.studentId;
        this.taxonomyFiler.loadFilterOutside(this.studentId);
        this.taxonomyFiler.$on('listActiveFacets', async (activeFacts: SubjectModel[]) => {
            if (!this.selectedSubjects.length) {
                this.selectedSubjects = [...new Map(activeFacts.map((item) => [item.id, item])).values()];
                const mindsetFW = this.selectedSubjects.filter((item: any) =>
                        this.taxonomyFiler.mindsetSubject.includes(item.id));
                this.selectedSubjects = this.selectedSubjects.filter(
                        (item: any) => !this.hiddenSubjects.includes(item.id)
                         && !this.taxonomyFiler.mindsetSubject.includes(item.id));
                const filteredSubject = this.selectedSubjects.filter((item: any) => item.id === 'K12.MA');
                const subjectItems = filteredSubject.map((subItem: any) => this.createSubjectCard(subItem));
                const mindsetFWItems = mindsetFW.map((item: any) => this.createSubjectCard(item, 'mindset'));
                this.storedBox = [...subjectItems, ...this.treeBox, ...mindsetFWItems];
                this.treeBox = [...this.storedBox].filter((box) => box.filterKey === 'knowledge-data');
                this.isLoading = false;
                // setTimeout(() => {this.$root.$emit('bv::show::popover'); }, 500);
            }
          });
    }

    private createSubjectCard(subject: any, filterCode = 'knowledge-data') {
        return {
            name: subject.title,
            icon: 'library_books',
            filterKey: filterCode,
            componentData: {
                name: 'learner-proficiency-chart-content',
                propData: {
                    subject: {
                        code: subject.code,
                        id: subject.code,
                        title: subject.title,
                    },
                    userId: this.studentId,
                    month: moment().format('MM'),
                    year: moment().format('YYYY'),
                    subjectCode: subject.code,
                    isCardView: true,
                },
            },
        };
    }

    private loadContent() {
        this.contentLoading = true;
        return new Promise((resolve: any) => {
            setTimeout(() => {
                resolve();
            }, 800);
        });

    }

}
